import * as React from 'react';

import { getResolvedDrumkitPortalBaseUrl } from '@utils/drumkitHostResolution';
import { getPageHeight } from '@utils/getPageHeight';
import { getMailboxEmailAddress } from '@utils/outlookMailbox';

import { Flex } from 'components/layout';
import { Typography } from 'components/typography';

import DrumkitIntro from '../components/DrumkitIntro';

export default function Signup(): React.JSX.Element {
  const pageHeight = getPageHeight();

  return (
    <div id='drumkit-content-view-root' style={{ height: `${pageHeight}px` }}>
      <Flex direction='col' align='center'>
        <DrumkitIntro />
        <a
          type='button'
          href={`${getResolvedDrumkitPortalBaseUrl(getMailboxEmailAddress(), null)}/signup`}
          target='_blank'
          className='bg-brand-main rounded-full shadow-md cursor-pointer mt-16 py-2 px-8 text-neutral-50 hover:bg-brand-600'
          rel='noreferrer'
        >
          Sign up for Drumkit
        </a>
        <Flex direction='col' gap='sm' align='center' className='mt-8'>
          <Typography variant='body-sm' align='center' className='my-2 mx-4'>
            Looks like you don't have a Drumkit account yet, sign up above.
          </Typography>
          <Typography variant='body-sm' align='center' className='my-2 mx-2'>
            Refresh this page when you&apos;re done.
          </Typography>
        </Flex>
      </Flex>
    </div>
  );
}
